import { fromJS } from 'immutable';
import { ACTIVE_BANK_CHANGE, ACTIVE_BANK_ENTRY_CHANGE, CLEAR_UI, MERGE_UI, SET_UI, TOGGLE_UI, OCCLUDE_QUIZ_ENTRIES, LOADED_API_FEATURES } from '@instructure/quiz-common';
var toggle = function toggle(state, key) {
  return state.update(key, function (value) {
    return !value;
  });
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CLEAR_UI:
      return state["delete"](action.payload);
    case MERGE_UI:
      return state.mergeDeepIn([action.payload.key], action.payload.value);
    case SET_UI:
      return state.setIn([action.payload.key].flat(), action.payload.value);
    case TOGGLE_UI:
      return toggle(state, action.payload);
    case OCCLUDE_QUIZ_ENTRIES:
      return state.set('quizEntriesOccluded', action.payload);
    case ACTIVE_BANK_CHANGE:
      return state.set('activeBankId', action.payload);
    case ACTIVE_BANK_ENTRY_CHANGE:
      return state.set('activeBankEntryId', action.payload);
    case LOADED_API_FEATURES:
      return state.set('loadedApiFeatures', action.payload);
    default:
      return state;
  }
});